import { render, staticRenderFns } from "./BabakJunior1.vue?vue&type=template&id=ad161532&scoped=true"
import script from "./BabakJunior1.vue?vue&type=script&lang=js"
export * from "./BabakJunior1.vue?vue&type=script&lang=js"
import style0 from "./BabakJunior1.vue?vue&type=style&index=0&id=ad161532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad161532",
  null
  
)

export default component.exports